import moment from 'moment';
import { FaCheckCircle, FaFileDownload } from 'react-icons/fa';

import { ObligationFile } from '../../operations/file/types';

export const getTagBackgroundColor = (file: ObligationFile) => {
  if (moment(file.due_at).isBefore(moment(), 'dates') && !file.viewed_at) {
    return 'var(--danger)';
  }

  return file.viewed_at ? 'var(--success)' : 'var(--info)';
};

export const getTagIcon = (file: ObligationFile) => {
  if (file.status === 'Pago') return <FaCheckCircle />;

  if (file.viewed_at) return <FaFileDownload />;

  return null;
};
